// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filter control for the table toolbar — a compact button + a downward popover
   that manages active criteria. Soft borders at rest; they whisper, not box. */
.filtermenu {
  position: relative;
  display: inline-block;
}

.filtermenu__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 0 12px;
  background: var(--bg);
  border: 1px solid var(--border-soft);
  border-radius: var(--r-data);
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
  cursor: pointer;
  transition:
    border-color 120ms ease,
    color 120ms ease,
    background 120ms ease;
}
.filtermenu__btn:hover {
  border-color: var(--border);
  color: var(--text);
}
.filtermenu__btn.is-active {
  border-color: var(--border);
  color: var(--text);
}
.filtermenu__ico {
  color: var(--text-muted);
}
.filtermenu__count {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: #fff;
  background: var(--signal);
  border-radius: var(--radius-full);
  padding: 1px 7px;
  line-height: 1.4;
}

/* Popover opens downward (the toolbar sits near the top of the viewport). */
.filtermenu__pop {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 40;
  min-width: 240px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--r-dialog);
  box-shadow: 0 12px 32px -10px rgba(10, 22, 51, 0.22);
  padding: 6px;
}

.filtermenu__label {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 6px 10px 4px;
}

/* "‹ Volver" — step back to the previous popover stage. */
.filtermenu__back {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 10px;
  margin-bottom: 2px;
  border: none;
  background: none;
  border-radius: var(--r-data);
  cursor: pointer;
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
  text-align: left;
}
.filtermenu__back:hover {
  background: var(--bg);
  color: var(--text);
}

/* Active criterion row: PROPIEDAD = valor ✕ */
.filtermenu__frow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 8px;
  border-radius: var(--r-data);
}
.filtermenu__frow:hover {
  background: var(--bg);
}
.filtermenu__fprop {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
  min-width: 84px;
}
.filtermenu__fop {
  color: var(--text-muted);
  font-family: var(--mono);
  font-size: var(--fs-sm);
}
.filtermenu__fval {
  flex: 1;
  text-align: left;
  border: none;
  background: none;
  padding: 0;
  color: var(--text);
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  font-weight: 500;
  cursor: pointer;
}
.filtermenu__fval:hover {
  color: var(--signal-deep);
}
.filtermenu__fx {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  border-radius: var(--radius-1);
  color: var(--text-muted);
  cursor: pointer;
  font-size: var(--fs-sm);
}
.filtermenu__fx:hover {
  background: var(--border-soft);
  color: var(--text);
}

.filtermenu__sep {
  height: 1px;
  background: var(--border-soft);
  margin: 5px 6px;
}

.filtermenu__add {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  background: none;
  border-radius: var(--r-data);
  color: var(--signal-deep);
  cursor: pointer;
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  font-weight: 500;
  text-align: left;
}
.filtermenu__add:hover {
  background: var(--signal-soft);
}

/* Property / value picker items */
.filtermenu__item {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 9px;
  padding: 7px 10px;
  border: none;
  background: none;
  border-radius: var(--r-data);
  cursor: pointer;
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
  text-align: left;
}
.filtermenu__item:hover {
  background: var(--signal-soft);
  color: var(--text);
}
.filtermenu__item.is-on {
  color: var(--text);
  font-weight: 500;
}
.filtermenu__item.is-disabled {
  color: var(--text-muted);
  cursor: default;
  opacity: 0.7;
}
.filtermenu__item.is-disabled:hover {
  background: none;
  color: var(--text-muted);
}
.filtermenu__gly {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  width: 16px;
  text-align: center;
}
.filtermenu__soon {
  margin-left: auto;
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.filtermenu__chk {
  margin-left: auto;
  color: var(--signal);
}

/* Searchable value picker (e.g. Tribunal) */
.filtermenu__search {
  width: 100%;
  height: 28px;
  margin: 2px 0 4px;
  padding: 0 9px;
  background: var(--bg);
  border: 1px solid var(--border-soft);
  border-radius: var(--r-data);
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  color: var(--text);
}
.filtermenu__search:focus {
  outline: none;
  border-color: var(--signal);
}
.filtermenu__scroll {
  max-height: 240px;
  overflow-y: auto;
}
.filtermenu__empty {
  padding: 10px;
  font-size: var(--fs-meta);
  color: var(--text-muted);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/ui/FilterMenu/FilterMenu.css"],"names":[],"mappings":"AAAA;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf;;;yBAGuB;AACzB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":["/* Filter control for the table toolbar — a compact button + a downward popover\n   that manages active criteria. Soft borders at rest; they whisper, not box. */\n.filtermenu {\n  position: relative;\n  display: inline-block;\n}\n\n.filtermenu__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 30px;\n  padding: 0 12px;\n  background: var(--bg);\n  border: 1px solid var(--border-soft);\n  border-radius: var(--r-data);\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition:\n    border-color 120ms ease,\n    color 120ms ease,\n    background 120ms ease;\n}\n.filtermenu__btn:hover {\n  border-color: var(--border);\n  color: var(--text);\n}\n.filtermenu__btn.is-active {\n  border-color: var(--border);\n  color: var(--text);\n}\n.filtermenu__ico {\n  color: var(--text-muted);\n}\n.filtermenu__count {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: #fff;\n  background: var(--signal);\n  border-radius: var(--radius-full);\n  padding: 1px 7px;\n  line-height: 1.4;\n}\n\n/* Popover opens downward (the toolbar sits near the top of the viewport). */\n.filtermenu__pop {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 40;\n  min-width: 240px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--r-dialog);\n  box-shadow: 0 12px 32px -10px rgba(10, 22, 51, 0.22);\n  padding: 6px;\n}\n\n.filtermenu__label {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: 6px 10px 4px;\n}\n\n/* \"‹ Volver\" — step back to the previous popover stage. */\n.filtermenu__back {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 6px 10px;\n  margin-bottom: 2px;\n  border: none;\n  background: none;\n  border-radius: var(--r-data);\n  cursor: pointer;\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  text-align: left;\n}\n.filtermenu__back:hover {\n  background: var(--bg);\n  color: var(--text);\n}\n\n/* Active criterion row: PROPIEDAD = valor ✕ */\n.filtermenu__frow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 8px;\n  border-radius: var(--r-data);\n}\n.filtermenu__frow:hover {\n  background: var(--bg);\n}\n.filtermenu__fprop {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  min-width: 84px;\n}\n.filtermenu__fop {\n  color: var(--text-muted);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n}\n.filtermenu__fval {\n  flex: 1;\n  text-align: left;\n  border: none;\n  background: none;\n  padding: 0;\n  color: var(--text);\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  font-weight: 500;\n  cursor: pointer;\n}\n.filtermenu__fval:hover {\n  color: var(--signal-deep);\n}\n.filtermenu__fx {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  border-radius: var(--radius-1);\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n}\n.filtermenu__fx:hover {\n  background: var(--border-soft);\n  color: var(--text);\n}\n\n.filtermenu__sep {\n  height: 1px;\n  background: var(--border-soft);\n  margin: 5px 6px;\n}\n\n.filtermenu__add {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  background: none;\n  border-radius: var(--r-data);\n  color: var(--signal-deep);\n  cursor: pointer;\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  font-weight: 500;\n  text-align: left;\n}\n.filtermenu__add:hover {\n  background: var(--signal-soft);\n}\n\n/* Property / value picker items */\n.filtermenu__item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 9px;\n  padding: 7px 10px;\n  border: none;\n  background: none;\n  border-radius: var(--r-data);\n  cursor: pointer;\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n  text-align: left;\n}\n.filtermenu__item:hover {\n  background: var(--signal-soft);\n  color: var(--text);\n}\n.filtermenu__item.is-on {\n  color: var(--text);\n  font-weight: 500;\n}\n.filtermenu__item.is-disabled {\n  color: var(--text-muted);\n  cursor: default;\n  opacity: 0.7;\n}\n.filtermenu__item.is-disabled:hover {\n  background: none;\n  color: var(--text-muted);\n}\n.filtermenu__gly {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  width: 16px;\n  text-align: center;\n}\n.filtermenu__soon {\n  margin-left: auto;\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.filtermenu__chk {\n  margin-left: auto;\n  color: var(--signal);\n}\n\n/* Searchable value picker (e.g. Tribunal) */\n.filtermenu__search {\n  width: 100%;\n  height: 28px;\n  margin: 2px 0 4px;\n  padding: 0 9px;\n  background: var(--bg);\n  border: 1px solid var(--border-soft);\n  border-radius: var(--r-data);\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  color: var(--text);\n}\n.filtermenu__search:focus {\n  outline: none;\n  border-color: var(--signal);\n}\n.filtermenu__scroll {\n  max-height: 240px;\n  overflow-y: auto;\n}\n.filtermenu__empty {\n  padding: 10px;\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
